/**
 * DIEUKYDIEU.TV - CATEGORY DETAIL CASCADING FILTERS
 */
import { getSectionsData, getSitemapTree } from './explore-data.js';
import { createChipElement, setActiveChip } from '../components/index.js';
import { initChipScroll } from '../chip-scroll.js';
import { updateFilterStatusBar, renderCategoryArticlesGrid, setupCategoryInfiniteScroll } from './explore-grid.js';

// Category Detail Cascading Filter state
export let currentDetailCategory = null;
export let currentDetailTreeCategory = null;
export let selectedTier1 = 'all';
export let selectedTier2 = 'all';
export let currentCategoryArticles = [];
export let filteredCategoryArticles = [];
export let categoryCurrentPage = 1;
export const categoryPageSize = 6;

export function openCategoryBySlug(slug, pushHistory = true) {
    if (!slug) return;
    const cleanSlug = slug.toLowerCase().trim();

    const sections = getSectionsData();
    const tree = getSitemapTree();

    let sec = sections.find(s => s.slug === cleanSlug || s.id === cleanSlug);
    let treeCat = tree.find(t => t.slug === cleanSlug || t.id === cleanSlug);

    let initialTier1 = 'all';
    if (!sec && Array.isArray(tree)) {
        for (const root of tree) {
            if (Array.isArray(root.children)) {
                const child = root.children.find(c => c.slug === cleanSlug || c.id === cleanSlug);
                if (child) {
                    sec = sections.find(s => s.id === root.id || s.slug === root.slug);
                    treeCat = root;
                    initialTier1 = child.name || child.id;
                    break;
                }
            }
        }
    }

    if (!sec && typeof window !== 'undefined' && window.SitemapService) {
        const found = window.SitemapService.findCategoryBySlug(cleanSlug);
        if (found) {
            sec = found.parentCategory ? sections.find(s => s.id === found.parentCategory.id) : found;
            treeCat = tree.find(t => t.id === (sec.id || found.id));
        }
    }

    if (!sec) sec = sections[0];
    if (!treeCat) treeCat = tree.find(t => t.id === sec.id) || sec;

    currentDetailCategory = sec;
    currentDetailTreeCategory = treeCat;
    selectedTier1 = initialTier1;
    selectedTier2 = 'all';
    categoryCurrentPage = 1;

    currentCategoryArticles = sec.articles ? [...sec.articles] : [];
    filteredCategoryArticles = [...currentCategoryArticles];

    const headingEl = document.getElementById('cat-detail-heading');
    if (headingEl) headingEl.textContent = sec.name;

    const iconEl = document.getElementById('cat-detail-icon');
    if (iconEl) iconEl.textContent = sec.icon || 'auto_awesome';

    const breadcrumbTitle = document.getElementById('cat-breadcrumb-title');
    if (breadcrumbTitle) breadcrumbTitle.textContent = sec.name;

    const totalBadge = document.getElementById('cat-article-total-badge');
    if (totalBadge) {
        totalBadge.textContent = `${currentCategoryArticles.length} bài viết`;
        totalBadge.style.display = 'none';
    }

    renderTier1Chips();
    collapseTier2Accordion();
    applyCategoryFilters(true);
    setupCategoryInfiniteScroll();

    if (typeof window.navigateToView === 'function') {
        window.navigateToView('category-detail-view', { pushHistory: false });
    }

    if (typeof window.updateSidebarActive === 'function') {
        window.updateSidebarActive('category-detail-view', sec.slug);
    }

    if (typeof window.updateUniversalFloatingBar === 'function') {
        window.updateUniversalFloatingBar('category-detail-view');
    }

    const cleanUrl = `/kham-pha/${sec.slug}`;
    if (pushHistory) {
        window.history.pushState({ viewId: 'category-detail-view', slug: sec.slug }, '', cleanUrl);
    } else if (window.location.pathname !== cleanUrl && !window.location.hash) {
        window.history.replaceState({ viewId: 'category-detail-view', slug: sec.slug }, '', cleanUrl);
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
}

export function closeCategoryDetail() {
    if (typeof window.navigateToView === 'function') {
        window.navigateToView('category-view');
    } else if (typeof window.handleSafeBack === 'function') {
        window.handleSafeBack('category-view', '/kham-pha');
    }
}


export function renderTier1Chips() {
    const tier1Container = document.getElementById('cat-tier1-chips');
    if (!tier1Container) return;
    tier1Container.innerHTML = '';

    const children = (currentDetailTreeCategory && currentDetailTreeCategory.children) ||
        (currentDetailCategory && currentDetailCategory.children) || [];

    const allChip = createChipElement({
        id: 'all',
        label: 'Tất cả',
        icon: 'apps',
        isActive: true,
        staggerIndex: 0,
        onClick: (id, chipEl) => onSelectTier1('all', chipEl)
    });
    tier1Container.appendChild(allChip);

    children.forEach((child, idx) => {
        const hasSub = child.subChildren && child.subChildren.length > 0;
        const chipBtn = createChipElement({
            id: child.id || child.slug,
            label: child.name,
            hasSubmenu: hasSub,
            isActive: false,
            staggerIndex: idx + 1,
            onClick: (id, el) => onSelectTier1(child, el)
        });
        chipBtn.setAttribute('data-child-id', child.id || child.slug);
        tier1Container.appendChild(chipBtn);
    });

    initChipScroll(tier1Container);
}

export function onSelectTier1(childOrAll, chipBtn) {
    setActiveChip('cat-tier1-chips', chipBtn);

    selectedTier1 = childOrAll;
    selectedTier2 = 'all';

    if (childOrAll === 'all' || !childOrAll.subChildren || childOrAll.subChildren.length === 0) {
        collapseTier2Accordion();
    } else {
        renderTier2Chips(childOrAll);
        expandTier2Accordion();
    }

    applyCategoryFilters(true);
}

export function renderTier2Chips(parentChild) {
    const tier2Container = document.getElementById('cat-tier2-chips');
    if (!tier2Container) return;
    tier2Container.innerHTML = '';

    const subChildren = parentChild.subChildren || [];

    const allSubChip = createChipElement({
        id: 'all',
        label: `Tất cả ${parentChild.name}`,
        variant: 'subchip',
        isActive: true,
        staggerIndex: 0,
        onClick: (id, chipEl) => onSelectTier2('all', chipEl)
    });
    tier2Container.appendChild(allSubChip);

    subChildren.forEach((sub, idx) => {
        const subChipBtn = createChipElement({
            id: sub.id || sub.slug || sub.name,
            label: sub.name,
            variant: 'subchip',
            isActive: false,
            staggerIndex: idx + 1,
            onClick: (id, el) => onSelectTier2(sub, el)
        });
        tier2Container.appendChild(subChipBtn);
    });

    initChipScroll(tier2Container);
}

export function expandTier2Accordion() {
    const accordion = document.getElementById('cat-tier2-accordion');
    if (accordion) {
        accordion.classList.add('expanded');
        accordion.setAttribute('aria-hidden', 'false');
        initChipScroll(document.getElementById('cat-tier2-chips'));
    }
}

export function collapseTier2Accordion() {
    const accordion = document.getElementById('cat-tier2-accordion');
    if (accordion) {
        accordion.classList.remove('expanded');
        accordion.setAttribute('aria-hidden', 'true');
    }
    const tier2Container = document.getElementById('cat-tier2-chips');
    if (tier2Container) {
        tier2Container.innerHTML = '';
    }
}

export function onSelectTier2(subChildOrAll, chipBtn) {
    setActiveChip('cat-tier2-chips', chipBtn);
    selectedTier2 = subChildOrAll;
    applyCategoryFilters(true);
}

export function applyCategoryFilters(resetToPageOne = true) {
    if (resetToPageOne) {
        categoryCurrentPage = 1;
    }

    const all = currentCategoryArticles || [];

    if (!selectedTier1 || selectedTier1 === 'all') {
        filteredCategoryArticles = [...all];
    } else if (selectedTier2 && selectedTier2 !== 'all') {
        const targetName = (selectedTier2.name || selectedTier2).toLowerCase().trim();
        const targetSlug = (selectedTier2.slug || '').toLowerCase().trim();
        filteredCategoryArticles = all.filter(art => {
            const tag = (art.tag || '').toLowerCase().trim();
            const parentTag = (art.parentTag || '').toLowerCase().trim();
            return tag === targetName || tag === targetSlug || parentTag === targetName;
        });
    } else {
        const tier1Name = (selectedTier1.name || selectedTier1).toLowerCase().trim();
        const tier1Slug = (selectedTier1.slug || '').toLowerCase().trim();
        const validTags = [tier1Name, tier1Slug];

        if (selectedTier1.subChildren && Array.isArray(selectedTier1.subChildren)) {
            selectedTier1.subChildren.forEach(s => {
                if (s.name) validTags.push(s.name.toLowerCase().trim());
                if (s.slug) validTags.push(s.slug.toLowerCase().trim());
            });
        }

        filteredCategoryArticles = all.filter(art => {
            const tag = (art.tag || '').toLowerCase().trim();
            const parentTag = (art.parentTag || '').toLowerCase().trim();
            return validTags.includes(tag) || validTags.includes(parentTag);
        });
    }

    updateFilterStatusBar();
    renderCategoryArticlesGrid(resetToPageOne);
}

export function setCategoryCurrentPage(p) { categoryCurrentPage = p; }
export function setFilteredCategoryArticles(list) { filteredCategoryArticles = list; }
export function setCurrentCategoryArticles(list) { currentCategoryArticles = list; }
export function setCurrentDetailCategory(c) { currentDetailCategory = c; }
